"use client";

import type { SnookerTemplateData } from "../snooker-template";
import { ActivityCourtPreview } from "./activity-court-preview";

type SnookerDisplayPreviewProps = {
  data: SnookerTemplateData | null;
  participants: {
    id: string;
    displayName: string;
    avatarUrl: string | null;
    username: string | null;
  }[];
};

export function SnookerDisplayPreview({
  data,
  participants,
}: SnookerDisplayPreviewProps) {
  if (!data) {
    return (
      <ActivityCourtPreview
        activityId="snooker"
        yourTeam={[]}
        opponentTeam={[]}
      />
    );
  }

  const yourTeam = participants.filter(
    (p) => data.positions[p.id] === "your-team",
  );
  const opponentTeam = participants.filter(
    (p) => data.positions[p.id] === "opponent-team",
  );
  const showScore = data.hasScore !== false;
  const yourWon = data.matchScore.yourFrames > data.matchScore.opponentFrames;

  return (
    <div>
      <ActivityCourtPreview
        activityId="snooker"
        yourTeam={yourTeam}
        opponentTeam={opponentTeam}
        yourWon={showScore ? yourWon : undefined}
        matchScore={showScore ? data.matchScore : undefined}
        frames={data.frames}
        highestBreak={data.highestBreak}
      />
    </div>
  );
}
